export default __webpack_public_path__ + "static/media/gallery159_1.322d849b.png";